import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-doc-file-icon',
  templateUrl: './doc-format-doc-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatDocFileIconComponent {}
